import { getLeadersText } from '@/utils/common'

export const getEventsFromRageDate = (range, events) => {
  const from = new Date(range[0]).getTime()
  const to = new Date(range[1]).getTime()
  const inverse = to < from
  const oneDate = !to
  return events.filter(event => {
    const eventTime = new Date(event.startDate).getTime()
    if (oneDate) return from <= eventTime && eventTime <= from
    if (inverse) return to <= eventTime && eventTime <= from
    return from <= eventTime && eventTime <= to
  })
}

export const getEventsPerLeader = (range, events, leadersMap) => {
  const list = getEventsFromRageDate(range, events)
  const acum = list.reduce((acc, event) => {
    if (event.leaders && event.leaders.length) {
      const acumL = event.leaders.reduce(
        (accL, leaderId) => ({
          ...accL,
          [leaderId]: (acc[leaderId] || 0) + 1
        }),
        {}
      )
      return { ...acc, ...acumL }
    }
    return acc
  }, {})
  return Object.keys(acum).map(key => ({
    id: key,
    leader: getLeadersText([key], leadersMap),
    email: leadersMap[key].email,
    count: acum[key]
  }))
}
